const state = {
    itemID: [],
    loading: false
};

export default state;